<template>
  <div class="wrapper">
    
    <parallax
      class="section page-header header-filter"
      :style="{ backgroundImage: 'url(' + header_pictures.products_header_picture.url + ')' }"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="products-section">
            
            <div class="products-container">
                
              <form class="products-search" v-on:submit.prevent="searchProducts">
                <md-field class="md-form-group">
                    <md-icon>search</md-icon>
                    <md-input
                      placeholder="Search products"  
                      v-model="searchQuery"
                    ></md-input>
                </md-field>
                <md-button class="md-primary" type="submit">Search</md-button>
              </form>
              <h2>Products: </h2>
              <br>
              <Loader v-if="loading"/>
              <div class="products-container-with-filter" v-else>
                <form v-on:submit.prevent="filterProducts">
                  <div class="products-filter">
                    <div class="filter-type">
                      <label for="category">Category:</label>
                      <select name="category" id="category" v-model="filter.category">
                        <option value='' selected="selected">Any Category</option>
                        <option :value=category.id v-for="category in categories" :key="category.id">{{category.Name}}</option>
                      </select>
                    </div>
                    <div class="filter-type">
                      <label for="application">Industry:</label>
                      <select name="application" id="application" v-model="filter.application">
                        <option value='' selected="selected">Any Industry</option>
                        <option :value=application.id v-for="application in applications" :key="application.id">{{application.name}}</option>
                      </select>
                    </div>
                    <div class="filter-type">
                      <label for="brand">Brand:</label>
                      <select name="brand" id="application" v-model="filter.brand">
                        <option value='' selected="selected">Any Brand</option>
                        <option :value=brand.id v-for="brand in brands" :key="brand.id">{{brand.Name}}</option>
                      </select>
                    </div>
                    <md-button class="md-primary" type="submit">Filter</md-button>
                  </div>
                  
                </form>
                <div>
                  <NoProducts
                    v-if="products.length === 0"
                  ></NoProducts>
                  <div class="products-items-container" >
                    <div class="" v-for="product in products" :key="product.id">
                      <Productcard :product=product></Productcard>
                    </div>
                  </div>
                  <div v-if="isSearchQuery === false">
                    <pagination
                      v-if="products_pages_count != 1"
                      class=""
                      v-model="products_page"
                      with-text
                      :page-count=products_pages_count
                      v-on:click.native="queryProductsPage"
                    >
                    </pagination>
                  </div>
                </div>
              </div>
                
            </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Pagination } from "@/components";
import Loader from "@/components/Loader.vue";
import Productcard from "@/components/Productcard.vue";
import NoProducts from "@/components/NoProducts.vue";

export default {
  components: {
    Loader,
    Pagination,
    Productcard,
    NoProducts
  },
  bodyClass: "profile-page",
  data() {
    return {
      loading: true,
      products: [],
      applications: [],
      categories: [],
      brands: [],
      categoryurl: '',
      applicationurl: '',
      productsearchurl: '',
      products_count: 0,
      products_pages_count: 1,
      products_page: 1,
      start: 0,
      limit: 24,
      queryLimiter: '',
      searchName: '',
      searchQuery: '',
      searchQueryUrl: '',
      isSearchQuery: false,
      filter: {
        query: '',
        category: '',
        application: '',
        brand: '',
      }
    };
  },
  props: {
    header_pictures: Object,
    
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/products?_sort=Name:ASC&_limit=24", {}).then(
      (response) => {
        this.products = response.data;
        this.loading = false;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/products/count", {}).then(
      (response) => {
        this.products_count = response.data;
        this.products_pages_count = Math.ceil(this.products_count / 24);
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/product-applications?_sort=name:ASC", {}).then(
      (response) => {
        this.applications = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/categories?_sort=Name:ASC", {}).then(
      (response) => {
        this.categories = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/brands?_sort=Name:ASC", {}).then(
      (response) => {
        this.brands = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
  },
  computed: {
    
  },
  methods: {
    queryProductsPage(){
      this.limit = (this.products_page * 24);
      this.queryLimiter = ("_start=" + (this.limit - 24) + "&_limit=" + this.limit);
      axios.get(("https://strapi-asiongs.herokuapp.com/products?_sort=Name:ASC&" + this.queryLimiter), {}).then(
        (response) => {
          this.products = response.data;
        },
        (error) => {
          // console.log(error);
        }
      );
    },
    searchProducts(){
      if(this.searchQuery){
        this.searchQueryUrl = ("&Name_contains=" + this.searchQuery); 
        axios.get("https://strapi-asiongs.herokuapp.com/products?_sort=Name:ASC&" + this.searchQueryUrl + this.filter.query, {}).then(
          (response) => {
            this.products = response.data;
            this.isSearchQuery = true;
          },
          (error) => {
            // console.log(error);
          }
        );
      }
      else{
        this.searchQueryUrl = '';
        if(this.filter.application || this.filter.brand || this.filter.category){
          this.filterProducts();
        }
        else{
          this.queryProductsPage();
          this.isSearchQuery = false;
        }
      }
      this.paginate();
    },
    filterProducts(){
      if(this.filter.application && this.filter.brand && this.filter.category){
        this.filter.query = ("&product_applications=" + this.filter.application + "&brand=" + this.filter.brand + "&categories=" + this.filter.category);
      }
      else if(this.filter.category && this.filter.brand){
        this.filter.query = ("&categories=" + this.filter.category + "&brand=" + this.filter.brand);
      }
      else if(this.filter.category && this.filter.application){
        this.filter.query = ("&categories=" + this.filter.category + "&product_applications=" + this.filter.application);
      }
      else if(this.filter.brand && this.filter.application){
        this.filter.query = ("&brand=" + this.filter.brand + "&product_applications=" + this.filter.application);
      }
      else if(this.filter.category){
        this.filter.query = ("&categories=" + this.filter.category);
      }
      else if(this.filter.application){
        this.filter.query = ("&product_applications=" + this.filter.application);
      }
      else if(this.filter.brand){
        this.filter.query = ("&brand=" + this.filter.brand);
      }
      else{
        this.filter.query = '';
      }

      if(this.filter.application || this.filter.brand || this.filter.category){
        axios.get("https://strapi-asiongs.herokuapp.com/products?_sort=Name:ASC" + this.searchQueryUrl + this.filter.query, {}).then(
          (response) => {
            this.products = response.data;
            this.isSearchQuery = true;
          },
          (error) => {
            // console.log(error);
          }
        );
      }
      
      this.paginate();
    },

    paginate(){
      if(this.searchQueryUrl === '' && this.filter.brand === '' && this.filter.application === '' && this.filter.category === ''){
        this.isSearchQuery = false;
        this.queryProductsPage();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.navigation-breadcrumbs{
    display: flex;
    flex-direction: row;
}

.category-card{
    display: flex;
    flex-direction: column;
}

.products-section{
    margin: 24px;
    

    .products-search{
        // float: right;
        padding: 12px;
        display: flex;
        flex-direction: row;
        max-width: 600px;

        .md-field{
            margin-right: 12px;
        }
    }

    .products-container{
        padding: 24px;
        max-width: 1440px;
        margin: auto;
        
    }   

    
}

.products-container{
        padding: 24px;
        max-width: 1440px;
        margin: auto;

        .products-container-with-filter{
          @media only screen and (min-width: 640px) {
            display: grid;
            grid-template-columns:  minmax(240px , 1fr)  minmax(240px , 4fr);
            grid-gap: 16px;

          }
          
          .products-filter{
            padding: 16px;
            border: 1px solid #eeeeee;
            margin-bottom: 16px;

            .filter-type{
              
              margin: 8px 0px;
              display: flex;
              flex-direction: column;
              
            }

            select{
              padding: 8px;
              border: 1px solid #eeeeee;

            }
            

            .filter-item{
              padding: 8px;
            }

            .filter-label{
              color: white;
              background-color: #182e5a;

              h5{
                margin: 0;
              }
            }
          }

          .products-items-container{
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
            grid-auto-rows: 1fr;
            grid-gap: 16px;
            
          }
        }
        
    }   
</style>
